/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementCodeCompIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementCodeCompIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M11.3535 9.38089L9.70703 11.0274L11.3535 12.6739L10.6465 13.3809L8.29297 11.0274L10.6465 8.67386L11.3535 9.38089Z"
              fill="currentColor"
            />
            <path
              d="M15.707 11.0274L13.3535 13.3809L12.6465 12.6739L14.293 11.0274L12.6465 9.38089L13.3535 8.67386L15.707 11.0274Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.0625 1.69143C6.36097 1.52863 6.72203 1.52864 7.02051 1.69143L11.0176 3.8721C11.7124 4.25111 11.7124 5.24894 11.0176 5.62796L7.04199 7.7969V12.1573C7.04199 12.9163 6.22888 13.3987 5.5625 13.0352L1.52148 10.8311C1.20027 10.6559 1.00005 10.319 1 9.95315V4.75003C1 4.56706 1.10011 4.39819 1.26074 4.31057L6.0625 1.69143ZM2 9.95315L6.04199 12.1573V7.7969L2 5.59183V9.95315ZM2.54395 4.75003L6.54199 6.93069L10.5391 4.75003L6.54199 2.56936L2.54395 4.75003Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementCodeCompIcon.tags = [
  'code component',
  'code',
  'component',
  'components',
  'development',
  'module',
  'programming',
  'tools',
  'package',
];

ElementCodeCompIcon.category = 'Navigator';

ElementCodeCompIcon.iconSize = 16;
